import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger
} from '@repo/ui/accordion'
import { Button } from '@repo/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
	DialogTrigger
} from '@repo/ui/dialog'
import { useTranslation } from '@/lib/i18n'

export function MrBookImportInstructions() {
	const { t } = useTranslation()
	return (
		<Dialog>
			<DialogTrigger render={<Button size='sm' variant='link' />}>
				{t('po:export.mrbook_instructions.title')}
			</DialogTrigger>
			<DialogContent className='max-h-[calc(100dvh-2rem)] overflow-y-auto'>
				<DialogHeader>
					<DialogTitle>
						{t('po:export.mrbook_instructions.title')}
					</DialogTitle>
					<DialogDescription>
						{t('po:export.mrbook_instructions.description')}
					</DialogDescription>
				</DialogHeader>
				<ol className='list-decimal space-y-3 pl-5 text-sm'>
					<li>{t('po:export.mrbook_instructions.open')}</li>
					<li>{t('po:export.mrbook_instructions.new_reading')}</li>
					<li>{t('po:export.mrbook_instructions.separator')}</li>
					<li>{t('po:export.mrbook_instructions.order')}</li>
				</ol>
				<p className='text-sm'>
					{t('po:export.mrbook_instructions.once')}
				</p>
				<p className='text-muted-foreground text-sm'>
					{t('po:export.mrbook_instructions.supplier')}
				</p>
				<Accordion>
					<AccordionItem value='terminal-setup'>
						<AccordionTrigger className='py-2'>
							{t('po:export.mrbook_instructions.setup_title')}
						</AccordionTrigger>
						<AccordionContent>
							<p>{t('po:export.mrbook_instructions.setup')}</p>
						</AccordionContent>
					</AccordionItem>
				</Accordion>
			</DialogContent>
		</Dialog>
	)
}
